import { dropdownTriggerClassname } from "app/components/Dropdown";
import { TagIcon } from "app/components/Icons";
import Pill from "app/components/Pill";
import CustomTooltip from "app/components/Tooltip";
import CommonTagSelection from "app/containers/Features/components/CommonTagSelection";
import { selectTagList } from "app/redux/selector";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  selectedTags: string[];
  onTagsChange: (val: string[]) => void;
  onOpen: () => void;
  onClose: () => void;
}

const TagSelection: React.FC<Props> = ({
  onTagsChange,
  selectedTags,
  onClose,
  onOpen,
}) => {
  const tagList = useSelector(selectTagList);

  const handleSelectionChange = (updatedSelectedItems) => {
    if (onTagsChange) {
      onTagsChange(updatedSelectedItems);
    }
  };

  return (
    <div className="relative">
      <CommonTagSelection
        trigger={
          <button
            className={clsx(
              "flex flex-wrap items-center justify-between w-full px-2 py-2  ",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip
              text="Click to choose tag"
              className="flex flex-wrap items-center gap-1 w-full "
              position="left"
            >
              {selectedTags?.length > 0 ? (
                <div className="flex gap-2 w-full">
                  <TagIcon size={20} color="#79808A" />
                  <div className="flex flex-wrap  gap-2 w-full ">
                    {tagList
                      .filter((tag) => selectedTags?.includes(tag._id))
                      .map((ele) => {
                        return (
                          <Pill
                            key={ele?.title}
                            className="!px-[6px] max-w-[141px] "
                            backgroundColor={ele?.color}
                            name={ele?.title}
                          />
                        );
                      })}
                  </div>
                </div>
              ) : (
                <span className="text-xs leading-[18px] font-normal text-secondary ">
                  Choose tag
                </span>
              )}
            </CustomTooltip>
          </button>
        }
        className="min-w-[255px]  py-2"
        dropdownContainerClassName="!max-h-[200px]"
        selectedTags={selectedTags}
        onTagsChange={(tagIds) => {
          handleSelectionChange(tagIds);
        }}
        isHeader="Tags"
        onClose={onClose}
        onOpen={onOpen}
      />
    </div>
  );
};

export default TagSelection;
